import React from 'react';
import { CtaButton } from './CtaButton';
export function Close() {
  return <section className="w-full border-y-4 border-gold bg-plum" data-id="element-43" data-mp="1zxfr213qncea">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-44" data-mp="1zy7cwk7j9vrd">
        <h2 className="font-display font-semibold text-white text-3xl sm:text-5xl" data-id="element-45" data-mp="1ux1k6mdvi8hu">
          Keep your evenings.{' '}
          <span className="text-gold" data-id="element-46" data-mp="1pz01i2kd0b6w">Open the Run Sheet and run the table.</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-base text-white/75" data-id="element-47" data-mp="1l1q33xezsp6x">
          First seats, session zero, weekly episodes, mid-campaign arcs, special
          tables and finales. Fifty-seven sessions, read once, run anywhere.
        </p>

        <div className="mx-auto mt-8 flex max-w-lg flex-wrap items-center justify-between gap-3 rounded-3xl border border-gold bg-gold/10 px-5 py-4 text-left" data-id="element-48" data-mp="178qmfs3h4oxs">
          <div data-id="element-49" data-mp="128vynxezwfgy">
            <span className="block text-[10px] font-semibold uppercase tracking-widest text-gold" data-id="element-50" data-mp="12bs03vq1xma5">
              Complete package
            </span>
            <span className="text-[15px] font-semibold text-white" data-id="element-51" data-mp="3vf5atprt9izx">
              Paid Table Ready — 6 Volumes + 5 Bonuses
            </span>
          </div>
          <span className="font-display text-4xl font-semibold leading-none text-white" data-id="element-52" data-mp="42kdr99bo6ii">
            $27
          </span>
        </div>

        <div className="mx-auto mt-5 max-w-lg" data-id="element-53" data-mp="3qfivnasf9soh">
          <CtaButton data-id="element-54" data-mp="3qe7rh9v2eiwu">Yes, I want the full year — $27</CtaButton>
        </div>
        <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-white/60" data-id="element-55" data-mp="i11v8p8mwmrz">
          {['Secure checkout', 'Instant access', 'Money-back guarantee'].map(item => <li key={item} className="flex items-center gap-2" data-id="element-56" data-mp="81t2fzpi9e77">
                <span className="h-1.5 w-1.5 rounded-full bg-gold" data-id="element-57" data-mp="d0mi9ys9lhaj" />
                {item}
              </li>)}
        </ul>
      </div>
    </section>;
}